import { css } from "@emotion/react";
import type { PropsWithChildren } from "react";

import { VARIANTS_STYLES, VARIANTS_TAG } from "./constants";
import type { TextVariant } from "./types";

type TextProps = PropsWithChildren<{
    variant: TextVariant;
    align?: "left" | "center" | "right";
    className?: string;
}>;

export default function Text(props: TextProps) {
    const { variant = "body", align = "left", children, className } = props;

    const containerCss = css(
        {
            textAlign: align,
        },
        VARIANTS_STYLES[variant],
        className,
    );
    const Tag = VARIANTS_TAG[variant];
    return (
        <Tag className={className} css={containerCss}>
            {children}
        </Tag>
    );
}
